import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";
import { isRTL, selectedType } from "../../reducers";
import { getPropertyRegionsTitle } from "../../helpers/general-helpers";
import { Grid } from "semantic-ui-react";
import * as regionResultsActions from "../../actions/regionResultsActions";
import { RegionsHotelsGroup } from "../../components/RegionsHotelsGroup/RegionsHotelsGroup";
import { Header, PlaceHolder } from "../../components/common";
import qs from "qs";
import styles from "./styles.less";

class RegionResults extends Component {
  async componentDidMount() {
    // onLoad from generalHandlers of ScrollManager wrapper:
    // check whether scrolling up should be done, if do, scroll.
    this.props.onLoad();
    await this.loadData();
  }

  async componentDidUpdate(prevProps) {
    const { searchDataTimestamp } = this.props;
    const { searchDataTimestamp: prevSearchDataTimestamp } = prevProps;
    if (searchDataTimestamp && searchDataTimestamp > prevSearchDataTimestamp) {
      await this.loadData();
    }
  }

  async loadData() {
    const {
      selectedRegionId: regionId,
      selectedCityCode: cityCode,
      checkinDate: fromDate,
      checkoutDate: toDate,
      lang,
      paxList,
      actions,
      promoCode,
      selectedType
    } = this.props;
    const reqObj = { pax: paxList, fromDate, toDate, lang, promoCode };

    reqObj.searchOption = {
      value: regionId || cityCode,
      optionType: selectedType
    };

    await actions.getRegionResults(reqObj); // pause next execution
  }

  /// remove previous selection key and add the new selection key to query.
  /// push the updated data to browser histoy to change current route
  onHotelSelect = hotelId => {
    const { actions } = this.props;
    const getHotelRouteWithQuery = id => {
      const { routing } = this.props;
      const currentQuery = qs.parse(routing.location.search, {
        ignoreQueryPrefix: true
      });
      currentQuery.selectedRegionId = undefined;
      currentQuery.selectedCityCode = undefined;
      currentQuery.selectedHotelId = id;
      return {
        pathname: "/hotel",
        search: qs.stringify(currentQuery, { addQueryPrefix: true }),
        notifyRoute: this.props.notifyRouteChange
      };
    };

    actions.push(getHotelRouteWithQuery(hotelId));
  };

  onShowHotelDetailsClick = hotelId => {
    const { onShowHotelDetailsClick } = this.props;
    onShowHotelDetailsClick(hotelId);
  };

  filterByHotel = regions => {
    const { hotelFilter } = this.props;
    if (hotelFilter && hotelFilter.length > 0) {
      const hotelsAfterFilter = [];
      regions &&
        regions.forEach(region => {
          const hotels = [];
          region &&
            region.roomResult &&
            region.roomResult.forEach(hotel => {
              let index = hotelFilter.findIndex(
                r => r.hotelId == hotel.hotelId && r.hotelName == hotel.name
              );
              if (index > -1) {
                hotels.push(hotel);
              }
            });
          if (hotels && hotels.length > 0) {
            hotelsAfterFilter.push({
              ...region,
              roomResult: [...hotels]
            });
          }
        });
      return hotelsAfterFilter;
    } else {
      return regions;
    }
  };

  filterByPrice = regions => {
    const { minPriceRangeFilter, maxPriceRangeFilter } = this.props;
    if (minPriceRangeFilter > 0 || maxPriceRangeFilter > 0) {
      const regionsAfterFilter = [];
      regions.forEach(region => {
        const hotels = [];
        region &&
          region.roomResult &&
          region.roomResult.forEach(hotel => {
            let isInRange =
              Math.round(hotel.startFromPrice) >= minPriceRangeFilter &&
              Math.round(hotel.startFromPrice) <= maxPriceRangeFilter;
            if (isInRange) {
              hotels.push(hotel);
            }
          });
        if (hotels && hotels.length > 0) {
          regionsAfterFilter.push({
            ...region,
            roomResult: [...hotels]
          });
        }
      });
      return regionsAfterFilter;
    } else {
      return regions;
    }
  };

  filterRegions = regions => {
    const filteredByHotel = this.filterByHotel(regions);
    const filteredByPrice = this.filterByPrice(filteredByHotel);
    return filteredByPrice;
  };

  renderPageContent = () => {
    const {
      isRtl,
      titles,
      onShowHotelDetailsClick,
      regionResults,
      isMobileView,
      selectedType,
      propertyType,
      propertyTypePlural,
      checkinDate,
      checkoutDate,
      clubUserLoggedIn,
      discountClubConfig
    } = this.props;
    const filteredRegions = this.filterRegions(regionResults);
    return (
      <RegionsHotelsGroup
        regionResults={filteredRegions}
        titles={titles}
        isRtl={isRtl}
        isMobileView={isMobileView}
        selectedType={selectedType}
        onRegionHotelClick={this.onHotelSelect}
        onShowHotelDetailsClick={onShowHotelDetailsClick}
        propertyType={propertyType}
        propertyTypePlural={propertyTypePlural}
        checkinDate={checkinDate}
        checkoutDate={checkoutDate}
        clubUserLoggedIn={clubUserLoggedIn}
        discountClubConfig={discountClubConfig}
      />
    );
  };

  render() {
    const {
      isFetchingRegionResults,
      renderLoader,
      regionResults,
      isRtl,
      isMobileView,
      titles,
      propertyType,
      handleRegionResultsRef,
      placeHolders
    } = this.props;
    let hasResults = regionResults.length > 0;

    return (
      <div className={styles.regionResults} ref={handleRegionResultsRef}>
        <Grid.Row>
          <Grid.Column width={16}>
            <Header
              text={getPropertyRegionsTitle(titles, propertyType)}
              isRtl={isRtl}
              isMobileView={isMobileView}
            />
          </Grid.Column>
        </Grid.Row>
        <PlaceHolder
          placeHolders={placeHolders}
          component={"RegionResults"}
          location={"HeaderBottom"}
        />
        <Grid centered stretched className={styles.innerGrid}>
          {isFetchingRegionResults || !hasResults
            ? renderLoader(isFetchingRegionResults)
            : this.renderPageContent()}
        </Grid>
      </div>
    );
  }
}

RegionResults.propTypes = {
  lang: PropTypes.string,
  checkinDate: PropTypes.string,
  checkoutDate: PropTypes.string,
  paxList: PropTypes.array,
  titles: PropTypes.object,
  promoCode: PropTypes.string,
  isMobileView: PropTypes.bool,
  isRtl: PropTypes.bool,
  actions: PropTypes.object,
  selectedRegionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selectedCityCode: PropTypes.string,
  regionResults: PropTypes.array,
  isFetchingRegionResults: PropTypes.bool,
  routing: PropTypes.object,
  onShowHotelDetailsClick: PropTypes.func,
  renderLoader: PropTypes.func,
  selectedType: PropTypes.string,
  searchDataTimestamp: PropTypes.number,
  notifyRouteChange: PropTypes.func,
  onLoad: PropTypes.func,
  propertyType: PropTypes.string,
  propertyTypePlural: PropTypes.string,
  handleRegionResultsRef: PropTypes.func,
  placeHolders: PropTypes.array,
  hotelFilter: PropTypes.array,
  minPriceRangeFilter: PropTypes.number,
  maxPriceRangeFilter: PropTypes.number,
  clubUserLoggedIn: PropTypes.bool,
  discountClubConfig: PropTypes.object
};

function mapStateToProps(store) {
  const state = {
    lang: store.lang,
    checkinDate: store.checkinDate,
    checkoutDate: store.checkoutDate,
    titles: store.titles,
    promoCode: store.promoCode,
    viewDirection: store.viewDirection,
    isMobileView: store.isMobileView,
    isRtl: isRTL(store),
    selectedType: selectedType(store),
    selectedRegionId: store.selectedRegionId,
    selectedCityCode: store.selectedCityCode,
    paxList: store.paxList,
    regionResults: store.regionResults,
    isFetchingRegionResults: store.isFetchingRegionResults,
    routing: store.routing,
    searchDataTimestamp: store.searchDataTimestamp,
    propertyType: store.propertyType,
    propertyTypePlural: store.propertyTypePlural,
    placeHolders: store.placeHolders,
    hotelFilter: store.hotelFilter,
    minPriceRangeFilter: store.minPriceRangeFilter,
    maxPriceRangeFilter: store.maxPriceRangeFilter,
    clubUserLoggedIn: store.clubUserLoggedIn,
    discountClubConfig: store.discountClubConfig
  };
  return state;
}

function mapDispatchToProps(dispatch) {
  const combinedActions = {
    ...regionResultsActions,
    push
  };
  return {
    actions: bindActionCreators(combinedActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegionResults);



// WEBPACK FOOTER //
// ./src/containers/RegionResults/RegionResults.js